<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row class="row pt-5">
        <v-col class="mt-sm-20" m="12" md="7" lg="7">
          <div>
            <h2>
              <b
                >Maritech: Secure & Efficient File Sharing for Onshore &
                Offshore Operations</b
              >
            </h2>
            <br />
            Maritech provides comprehensive IT solutions designed for marine and
            offshore operations. Our services ensure seamless connectivity, data
            security, and efficient digital transformation to enhance your
            business operations.
            <br />
          </div>

          <div>
            <h2 class="pt-5">Key Features and Benefits</h2>
            <v-row align="top" no-gutters class="pt-4">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-server-network</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Network Infrastructure Setup</p>
                <p class="description">
                  Secure and scalable network solutions tailored for marine
                  environments.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-cloud</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Cloud & Data Storage Solutions</p>
                <p class="description">
                  Reliable NAS installation and cloud integration for seamless
                  data access and backup.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-security</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Cybersecurity & Compliance</p>
                <p class="description">
                  Protect your systems with industry-leading security measures
                  and compliance consulting.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-cogs</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Custom Software Solutions</p>
                <p class="description">
                  Development of bespoke applications for marine and offshore
                  operational needs.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-desktop-classic</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Hardware Deployment & Maintenance</p>
                <p class="description">
                  Expert setup and ongoing support for critical IT hardware.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-clock-outline</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">24/7 IT Support & Managed Services</p>
                <p class="description">
                  Ensure smooth operations with our dedicated support team.
                </p>
              </v-col>
            </v-row>
          </div>
          <div class="pt-5">
            <div><h2 class="pt-5 pb-4">Why Choose Us?</h2></div>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-briefcase-check </v-icon
              >&nbsp;
              <span class="sicon"
                ><b>Industry Expertise - </b>Years of experience in the marine
                industry.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-wrench-clock</v-icon>&nbsp;
              <span class="sicon"
                ><b>Reliable Support - </b>24/7 support to keep your operations
                running smoothly.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-puzzle</v-icon>&nbsp;
              <span class="sicon"
                ><b>Tailored Solutions - </b>Customized IT solutions that fit
                your specific requirements.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-shield-lock</v-icon>&nbsp;
              <span class="sicon"
                ><b>Security First Approach - </b>Ensuring data integrity and
                security in all implementations.</span
              >
            </v-col>
          </div>

          <div class="pt-5">
            <div><h2 class="pt-5 pb-4">Pricing</h2></div>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-check-circle </v-icon>&nbsp;
              <span class="sicon"
                ><b>One-time Implementation Fee:</b> Custom pricing based on
                project scope.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-check-circle </v-icon>&nbsp;
              <span class="sicon"
                ><b>Monthly Support & Maintenance: </b>Flexible plans to meet
                your needs.</span
              >
            </v-col>
          </div>

          <div class="pt-5">
            <h3>Get Started Today!</h3>
            <p class="pt-2">
              Ensure seamless operations with Maritech's advanced IT solutions.
              Contact us to discuss how we can support your business.
            </p>
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Maritech File Sharing";
  }
};
</script>

<style scoped>
.row {
  text-align: justify;
}
/* h3 {
  font-size: 20px;
  color: #033261;
} */

.icon-background {
  background-color: #c4e1f8;
  border-radius: 50%;
  padding: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  color: #080808;
  font-weight: bold;
  margin: 0;
}

.description {
  color: #333333;
  margin: 0;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
